// extracted by mini-css-extract-plugin
export default {"border":"ProgressBorder_border__NAk4p","fill":"ProgressBorder_fill__JMwff"};